import { Component, OnInit, Input } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid';
import { DriverScheduleService } from '../../driver-schedule.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { anchorPopupToSource } from '../../../../core/helpers/ag-grid-popup.util';


@Component({
  selector: 'app-history-schedule',
  templateUrl: './history-schedule.component.html',
  styleUrls: ['./history-schedule.component.scss']
})
export class HistoryScheduleComponent implements OnInit {

  @Input('selectedDate') selectedDate;
  @Input('selectedProvider') selectedProvider?;
  historyGrid: GridOptions;
  constructor(
    private service: DriverScheduleService,
    private loading: T2LoadingService,
    private toastrAlertHelper: ToastrAlertHelper,
  ) {
    this.getColumnDefs();
  }

  ngOnInit() {
  }

  /**
   * this get history data
   */
  private getHistory() {
    this.loading.show();
    this.service.getHistorySchedules(this.selectedDate, this.selectedProvider).finally(
      () => {
        this.loading.hiden();
      }
    ).subscribe(
      data => {
        this.historyGrid.api.setRowData(data);
      },
      error => {
        this.toastrAlertHelper.error(error.message);
      }
    )
  }

  /**
   * this return column defs
   */
  private getColumnDefs() {
    this.historyGrid = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressHorizontalScroll: true,
      postProcessPopup: (params) => {
        if (params && params.ePopup) {
          anchorPopupToSource(
            params.ePopup as HTMLElement,
            params.eventSource as HTMLElement,
          );
        }
      },
      columnDefs: [
        {
          headerName: 'Schedule History Id',
          field: 'schedulehistoryid',
          colId: 'schedulehistoryid',
          hide: true,
          suppressToolPanel: true
        },
        {
          headerName: 'Schedule Id',
          field: 'scheduleid',
          colId: 'scheduleid',
          width: 80
        },
        {
          headerName: 'Description',
          field: 'description',
          colId: 'description',
          width: 140
        }
        ,
        {
          headerName: 'Date',
          field: 'date',
          colId: 'date',
          width: 80
        }
        ,
        {
          headerName: 'Time',
          field: 'time',
          colId: 'time',
          width: 80
        }
        ,
        {
          headerName: 'User',
          field: 'userprofile.fullname',
          colId: 'userprofile.fullname',
          width: 80
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        event.api.sizeColumnsToFit();
        if (this.selectedDate) {
          this.getHistory();
        }
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/components/history-schedule/history-schedule.component.ts